import React from 'react';
import Close from '@material-ui/icons/Close';
import Back from '@material-ui/icons/KeyboardBackspace';

class Step extends React.Component {

    render() {
        const { intl, label } = this.props;
        return (
            <div className="flex_auto_row width100 padding_borders_flat margin_top_12 elements_from_right">
                <div className="ob_hide_on_desktop flex_auto_row align_center " onClick={this.props.onPrevious}>
                    <Back className="margin_right_6" />
                </div>
                <div className="flex_full_row ob_hide_on_desktop center ob_step_title">
                    {label && intl.formatMessage({ id: label })}
                </div>
                <Close
                    className="hand"
                    onClick={this.props.goTo(0)}
                />
            </div>
        );
    }
}

export default Step;


// WEBPACK FOOTER //
// ./src/components/complex/onboarding/backstep.js